import React from "react";

export enum TableType {
    TrackCount,
    TrackTime,
    ArtistCount,
    ArtistTime,
    AlbumCount,
    AlbumTime,
}

export enum TimeRange {
    AllTime = "All time",
    Last7Days = "Last 7 days",
    Last30Days = "Last 30 days",
    YTD = "This year so far",
    Custom = "Custom range...",
}

export interface TopItem {
    rank: number,
    count: number,
    image: string,
    artistIds: string[],
    artists: string[],
    albumId: string,
    album: string,
    trackId: string,
    track: string,
    artist: string,
    artistId: string,
    setEntityModal: (data: React.ReactElement | undefined) => void,
}

export interface DecadeBreakdown {
    decade: string,
    count: number,
}

export interface AveragePopularity {
    artistIds: string[],
    artists: string[],
    trackId: string,
    track: string,
    popularity: number,
}

export interface ModeYear {
    year: number,
    count: number,
}

export interface SearchResult {
    artists: string[],
    artistIds: string[],
    id: string,
    image: string,
    isTrack: boolean,
    name: string,
}